import { useEffect, useRef } from 'react';
import { BuildPath } from '../../../helpers/Paths';
import { Status, SideImageProps } from '../../../interfaces/unsplash';
import '../../../css/unsplash.scss';

const SideImage = (props:{data:SideImageProps}) => {

    const {status, count, bigImage, save, btnSaved, savedImages, isModal} = props.data;

    const addBtnRef = useRef<HTMLButtonElement | null>(null);

    useEffect(() => {

        if (savedImages.length && addBtnRef.current){
            addBtnRef.current.removeAttribute("disabled");
        }

    }, [bigImage])

    if (status === Status.inital || count === 0){
        return null;
    }

    const thumbnailUrl = (src:string): string => {
        return `${src.split('?')[0]}?w=270`;
    }

    const name = (): string => {

        const split = bigImage?.creditLink.split('@');

        if (split?.length === 0){
            return String(bigImage?.name);
        }

        const link = split;

        if (Number(link?.length) > 0){
           return `@${String(link?.[1])}`;
        }
           
        return bigImage?.name ?? "";
    }

    const btnClick = (): void => {

        if (addBtnRef?.current?.getAttribute?.("disabled") === "true"){
            return;
        }

        addBtnRef?.current?.setAttribute?.("disabled", "true");

        if (ImageAlreadySaved()){
            return;
        }
        
        save();
    }

    const btnImagePath = (): string => {
        if (showBtnSaved()){
            return `${BuildPath()}/images/unsplash/imageaddedtickicon.svg`;
        }

        return `${BuildPath()}/images/unsplash/addtolibraryicon.svg`;
    }

    const ImageAlreadySaved = ():boolean => {
        return !!(bigImage && savedImages.filter(x => x.id === bigImage.id).length);
    }

    const showBtnSaved =():boolean =>  {

        // New click
        if (btnSaved){
            return true;
        }

        // Existing click
        return !!savedImages.filter(x => x.id === bigImage?.id).length;


    }

    const isIE11 = ():string => {

        var isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;

        if (isIE11){
            return "ie11String"
        }

        return "";

    }
  
    if (bigImage){
        return (
            <section className="big-image-container big-image-border">
                <div className="big-image-spacer">
                    <img className="big-image" src={thumbnailUrl(bigImage.imageRegular)} alt={bigImage.altDes} /> 
                </div>
                <section>
                    <h3>Filename</h3>
                    <p className={isIE11()}>{bigImage.filename}</p>
                    <h3>Source</h3>
                    <p>Unsplash by <a href={bigImage.creditLink} target="_blank">{name()}</a></p>
                </section>
                      
                {!isModal && 
                    <button ref={addBtnRef} className={showBtnSaved() ? 'add-to-lib add-to-lib-saved' :'add-to-lib'} onClick={btnClick} > 
                        <img src={btnImagePath()} alt=""/> {showBtnSaved() ? 'Image added' : 'Add to library' } 
                    </button>
                }
                
            </section>
        )
    }
    
    return (
        <div className="no-image-container big-image-border">
            <section>
                <img alt="" className='no-image-selected' src={`${BuildPath()}/images/unsplash/missing_image.svg`} />
                <span className='nothing-selected'>Nothing selected</span>
            </section> 
        </div>    
    )
    
}
export default SideImage;